module.exports = {
    "baseUrl": "https://api-v4.staging.primrose.health",
    "systemName": "System dev",
    "checkinUrl": "https://checkin.staging.primrose.health",
    "appointmentPortal": "https://a.trillium.health",
    "companyTitle": "Appointment reminder | Trillium Health",
    "metaTitle": "Appointment reminder",
    "favicon": "%PUBLIC_URL%/favicon.png",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium",
    "cdnUrl": "https://cdn.staging.primrose.health"
}